import React from 'react'
import { CustomPopoverWhite } from '../CustomPopover/CustomPopoverWhite'

export const ItemSelectableWithOptions = ({ children, options, onclick, idPopover }) => {

    return (
        <>
            <div
                className='shadow-sm pt-3 ps-3 pe-3 pb-3 rounded-3 d-flex align-items-center justify-content-between'
                style={{ background: 'var(--white)' }}
                onClick={onclick}
            >
                {children}

                <div>
                    <CustomPopoverWhite
                        idPopover={idPopover}
                        trigger='focus'
                        buttonIcon={<i style={{ color: 'var(--gray-600)' }} className="fa-solid fa-ellipsis-vertical"></i>}
                        buttonClassName='border-0 shadow-none'
                        options={options}
                    />
                </div>

            </div >
        </>
    )
}
